import React, { useEffect, useState, useRef } from "react";
import Icd10Service from "../../../../services/Icd10Service";
import Icons from "../../../../components/UI/Icons";
import EmrConfigService from "../../../../services/EmrConfigService";
import FormInputs from "../../../../components/UI/FormInputs";
import { convertUnderScoreStrings } from "../../../../utils/commonUtils";
import EmrVisitsService from "../../../../services/EmrVisitsService";
import AiDiagnosisService from "../../../../services/AiDiagnosisService";
import withReduxState from "../../../../hoc/wReduxState";

const NewIcdDisplay = ({ bodyparts, onToggle, selectedCodes = [] ,visit_id,setSelecetedBodyParts,isrenderICD,setSelectedIcdCodes,Loader,Toast,diagnoses,setDiagnoses,setIsFormDirty,profile,...props}) => {
  const [icdList, setIcdList] = useState([]);
  // const [selectedCodes, setSelectedCodes] = useState([]);
  const [searchTerm,setSearchTerm]= useState("")
  const [isAiPredictiveOpen, setIsAiPredictiveOpen] = useState(true);
  const [aiSuggestions, setAiSuggestions] = useState([]);
  const [aiLoading, setAiLoading] = useState(false);
  const [aiLoadingStep, setAiLoadingStep] = useState(0);
  const [aiError, setAiError] = useState("");
  const [lastKnownSuggestionTimestamp, setLastKnownSuggestionTimestamp] = useState(null);
  const [newSuggestionsAvailable, setNewSuggestionsAvailable] = useState(false);
  const [isPollingForNewSuggestions, setIsPollingForNewSuggestions] = useState(false);
  const [hasCompletedPolling, setHasCompletedPolling] = useState(false);
  // Keep this aligned with AIPrediction gating logic.
  const aiSuggestionsEnabled = profile?.ai_suggestions_enabled ?? false;
  const normalizeId = (value) => (value === undefined || value === null ? "" : String(value));
  const aiPredictiveCardStyle = {
    padding: "8px",
    borderRadius: "12px",
    border: "2px solid transparent",
    background:
      "linear-gradient(#fff, #fff) padding-box, linear-gradient(76.49deg, #C6CCFF 0.38%, #F1F3FC 99.62%) border-box",
  };
  const aiPredictiveListStyle = {
    background: "linear-gradient(180deg, #FFE9FF 0%, #FDEFFF 40%, #FDF3FF 100%)",
    padding: "8px",
    maxHeight: "380px",
    overflowY: "auto",
    scrollbarWidth: "thin",
    borderRadius: "8px",
  };
  const aiPredictiveTitleStyle = {
    color: "#1D2433",
    fontSize: "13px",
    fontWeight: 700,
  };
  const aiPredictiveCodeStyle = { color: "#1D2433", fontSize: "13px", fontWeight: 700, lineHeight: 1.25 };
  const aiPredictiveDescStyle = { color: "#4B5563", fontSize: "13px", lineHeight: 1.35 };
  const aiChevronStyle = {
    transform: isAiPredictiveOpen ? "rotate(180deg)" : "rotate(0deg)",
    transition: "transform 0.2s ease",
    cursor: "pointer",
  };
  const aiLoadingMessages = [
    "Reviewing chief complaint and clinical findings...",
    "Analyzing history, exam, and encounter data...",
    "Identifying supported clinical conditions...",
    "Applying ICD-10 specificity and combination rules...",
    "Validating diagnoses against documentation...",
    "Ranking diagnoses by clinical confidence...",
    "Finalizing ICD-10 assessment suggestions...",
  ];

  useEffect(() => {
    if (!aiLoading) {
      setAiLoadingStep(0);
      return;
    }

    const intervalId = setInterval(() => {
      setAiLoadingStep((prev) => {
        const next = prev + 1;
        return next >= aiLoadingMessages.length ? prev : next;
      });
    }, 2000);

    return () => clearInterval(intervalId);
  }, [aiLoading]);
  // const isFirstRender = useRef(true);
 console.log("isrenderICD",bodyparts);
  useEffect(()=>{    
  //  if (isFirstRender.current) {
  //     isFirstRender.current = false;
  //     return;
  //   }
    
    if(searchTerm !=='' || bodyparts.length>0){
      const delay = setTimeout(() => {
        fetchIcdList(bodyparts);
      }, 300);
      return () => clearTimeout(delay);
    }else{
       setIcdList([]);
    }
    
  },[isrenderICD,searchTerm])

  useEffect(() => {
    // icdList.forEach((item) => {
    //   const isManuallyChecked = selectedCodes.some((icd) => icd.code === item.code);
    //   const shouldBeAutoChecked = !!item.assessment_id && item.is_updated === true;
  
    //   if (!isManuallyChecked && shouldBeAutoChecked) {
    //     toggleCode(item.code, item.assessment_id, item.icd10_id,item.body_parts); // ✅ fix
    //   } 
    // });
  }, [icdList]);

  const getLatestSuggestionTimestamp = (suggestions = []) => {
    if (!suggestions.length) return null;
    const latestSuggestion = suggestions.reduce((latest, current) => {
      const currentTime = new Date(current.created_at || 0).getTime();
      const latestTime = new Date(latest.created_at || 0).getTime();
      return currentTime > latestTime ? current : latest;
    }, suggestions[0]);
    return latestSuggestion?.created_at || null;
  };

  const fetchStoredSuggestions = async (checkForNew = false) => {
    if (!visit_id || !aiSuggestionsEnabled) return;
    try {
      setAiLoading(true);
      setAiError("");

      let data = await AiDiagnosisService.getSuggestions(visit_id, 'assessment');
      let newSuggestions = data?.suggestions || [];

      // If this is an initial fetch (not a "checkForNew") and we have
      // no stored suggestions yet, auto-trigger generation like other AI panels.
      if (!checkForNew && newSuggestions.length === 0) {
        const organizationId =
          props.organizationId ||
          props.organization_id ||
          props.organizationuuid ||
          props.visitDetails?.organization_id;

        if (visit_id && organizationId) {
          await AiDiagnosisService.generateSuggestionsByVisit(
            visit_id,
            organizationId,
            props.employeeId || props.employee_id || null,
            'assessment'
          );
          data = await AiDiagnosisService.getSuggestions(visit_id, 'assessment');
          newSuggestions = data?.suggestions || [];
        }
      }

      if (checkForNew) {
        if (newSuggestions.length > 0) {
          const latestTimestamp = getLatestSuggestionTimestamp(newSuggestions);
          if (
            latestTimestamp &&
            (!lastKnownSuggestionTimestamp ||
              lastKnownSuggestionTimestamp === "CHECKED_EMPTY" ||
              new Date(latestTimestamp).getTime() > new Date(lastKnownSuggestionTimestamp).getTime())
          ) {
            setNewSuggestionsAvailable(true);
            setIsPollingForNewSuggestions(false);
            setLastKnownSuggestionTimestamp(latestTimestamp);
            setHasCompletedPolling(true);
          }
        } else {
          setHasCompletedPolling(true);
        }
      } else if (newSuggestions.length > 0) {
        const latestTimestamp = getLatestSuggestionTimestamp(newSuggestions);
        if (latestTimestamp) {
          setLastKnownSuggestionTimestamp(latestTimestamp);
        }
      } else if (lastKnownSuggestionTimestamp === null) {
        setLastKnownSuggestionTimestamp("CHECKED_EMPTY");
      }

      setAiSuggestions(newSuggestions);
    } catch (err) {
      setAiError(err?.message || "Unable to fetch suggestions");
    } finally {
      setAiLoading(false);
    }
  };

  useEffect(() => {
    if (!visit_id || !aiSuggestionsEnabled) return;
    fetchStoredSuggestions();
    setHasCompletedPolling(false);
  }, [visit_id, aiSuggestionsEnabled]);

  useEffect(() => {
    if (!visit_id || !isPollingForNewSuggestions || !aiSuggestionsEnabled) return;

    let pollCount = 0;
    const startedWithNoSuggestions = !lastKnownSuggestionTimestamp || lastKnownSuggestionTimestamp === "CHECKED_EMPTY";
    const maxPolls = startedWithNoSuggestions ? 5 : 15;
    let pollInterval = null;

    const poll = async () => {
      pollCount++;
      await fetchStoredSuggestions(true);
      if (pollCount >= maxPolls) {
        if (pollInterval) {
          clearInterval(pollInterval);
        }
        setIsPollingForNewSuggestions(false);
        setHasCompletedPolling(true);
      }
    };

    poll();
    pollInterval = setInterval(poll, 2000);

    return () => {
      if (pollInterval) clearInterval(pollInterval);
    };
  }, [visit_id, isPollingForNewSuggestions, lastKnownSuggestionTimestamp, aiSuggestionsEnabled]);

  useEffect(() => {
    if (!aiSuggestionsEnabled) return;
    const handleEmrSave = () => {
      setIsPollingForNewSuggestions(true);
      setNewSuggestionsAvailable(false);
      setHasCompletedPolling(false);
    };
    window.addEventListener("emr-saved", handleEmrSave);
    return () => window.removeEventListener("emr-saved", handleEmrSave);
  }, [aiSuggestionsEnabled]);


  const fetchIcdList = async (bodyparts) => {
    try {
      // const payload = { body_parts: bodyparts };
      setSelectedIcdCodes([])
      Loader(true)
      const response = await EmrVisitsService.getAssessmentICD10DList(
        null,
        visit_id,
        {
          body_parts:bodyparts || "",
          search_query:searchTerm||""
        }
      );
      Loader(false)
     // console.log(response);
      const icdList = response?.data || [];
      const bodyPartsList=icdList.map(itm=>itm.body_parts);
      // console.log("bodyPartsList",bodyPartsList);
      const updatedBodyParts=new Set([...bodyparts,...bodyPartsList]);
      // console.log(updatedBodyParts,"updatedBodyParts");
            // console.log( typeof [...updatedBodyParts],"updatedBodyParts type of");

      // setSelecetedBodyParts([...updatedBodyParts]);
      setIcdList(icdList);
    } catch (err) {
      Loader(false)
      Toast.error("Something went wrong.");
      console.error("Error fetching ICD-10 list", err);
    }
  };

  const toggleCode = (code, assessment_id, icd10_id,body_parts) => {
    const isChecked = selectedCodes.some((icd) => icd.code === code);
    onToggle(code, !isChecked, assessment_id, icd10_id,body_parts);
  };
  

  
  
  const selectedCodeString = selectedCodes.join(",");
 const AddDiagnosis=(icd10_id,label)=>{
     const normalizedIcdId = normalizeId(icd10_id);
     if (diagnoses.some((d) => normalizeId(d) === normalizedIcdId)) return;
     const index = diagnoses.findIndex((d) => d === "");
     if (index === -1) {
         return;
     }
     if (setIsFormDirty) {
        setIsFormDirty(true);
     }
     const updated = [...diagnoses];
     updated[index] = icd10_id;
     props.setFormStates((prev) => ({
         ...prev,
         [`diagnosis_${index+1}`]: icd10_id,
         [`diagnosis_${index+1}_label`]:label
     }));
     setDiagnoses(updated);
 }
    const removeDiagnosis = (icd10_id,label) => {

        const index = diagnoses.findIndex((d) => d === icd10_id);
        if (index === -1) return; // id not found, do nothing
        if (setIsFormDirty) {
            setIsFormDirty(true);
        }
        const updated = [...diagnoses];
        updated[index] = ""; // clear that slot only
        props.setFormStates((prev) => ({
            ...prev,
            [`diagnosis_${index+1}`]: '',
            [`diagnosis_${index+1}_label`]:'',
        }));
        setDiagnoses(updated);
    }   
  const handleAcceptSuggestion = async (item) => {
    try {
      const organizationId =
        props.organizationId ||
        props.organization_id ||
        props.organizationuuid ||
        props.visitDetails?.organization_id;

      if (item?.id && organizationId && visit_id) {
        await AiDiagnosisService.acceptSuggestion(item.id, organizationId, visit_id);
      }

      const targetIcdId = item?.icd_id || item?.matched_icd_id || item?.icd10_id;
      if (targetIcdId) {
        const label = `${item.code} - ${convertUnderScoreStrings(item.description || "")}`;
        AddDiagnosis(targetIcdId, label);
      }

      // Reflect acceptance immediately in UI without requiring a refresh.
      // Use a stable fallback key because some suggestion rows may not have `id`.
      const clickedKey = normalizeId(
        item?.id ||
        item?.suggestion_id ||
        item?.icd_id ||
        item?.matched_icd_id ||
        item?.icd10_id ||
        item?.code
      );
      setAiSuggestions((prev) =>
        prev.map((suggestion) => {
          const suggestionKey = normalizeId(
            suggestion?.id ||
            suggestion?.suggestion_id ||
            suggestion?.icd_id ||
            suggestion?.matched_icd_id ||
            suggestion?.icd10_id ||
            suggestion?.code
          );
          return suggestionKey === clickedKey
            ? { ...suggestion, is_accepted: true, is_in_assessment: true }
            : suggestion;
        })
      );

      await fetchStoredSuggestions();
      if (typeof props.refreshAssessmentModel === "function") {
        await props.refreshAssessmentModel();
      }
      if (Toast?.success) {
        Toast.success("Suggestion accepted and added to assessment");
      }
    } catch (err) {
      if (Toast?.error) {
        Toast.error(err?.message || "Unable to accept suggestion");
      }
    }
  };

  const handleReloadSuggestions = async (e) => {
    if (e) {
      e.stopPropagation();
    }

    try {
      const organizationId =
        props.organizationId ||
        props.organization_id ||
        props.organizationuuid ||
        props.visitDetails?.organization_id;

      if (!visit_id || !organizationId) {
        if (Toast?.error) {
          Toast.error("Missing visit or organization details");
        }
        return;
      }

      setAiLoading(true);
      await AiDiagnosisService.generateSuggestionsByVisit(
        visit_id,
        organizationId,
        props.employeeId || props.employee_id || null,
        'assessment'
      );
      await fetchStoredSuggestions();
      setNewSuggestionsAvailable(false);

      if (Toast?.success) {
        Toast.success("AI suggestions reloaded");
      }
    } catch (err) {
      if (Toast?.error) {
        Toast.error(err?.message || "Unable to reload AI suggestions");
      }
    } finally {
      setAiLoading(false);
    }
  };

  return (
    <div className="col-3">
      <div className="card sh_basecard">
        <div
          className="sh_cardBox sh_emrfieldcardbox mb-1"
         
        >
          <div className="card-header p-2 sh_basecardHeader">
            <div class="d-flex w-100 justify-content-between align-items-center ">
                Charts
            </div>

            <div className=" emrinlinesearchbox ">
              {/* <Buttons
             className="emrinlinesearchicon btn btn-icon btn-transparent-dark"
             clickHandler={handleSearch}
             iconType={"SearchDarkBg"}
             /> */}
              <button
                type="button"
                className="emrinlinesearchicon btn btn-icon btn-transparent-dark"
                // onClick={handleSearch}
              >
                <Icons type={"SearchDarkBg"} />
              </button>
              <FormInputs
                type="text"
                name="text"
                className="emrinlinesearchinput"
                placeholder="search ICD..."
                value={searchTerm}
                changeHandler={(val) => {
                  setSearchTerm(val);
                }}
              />
            </div>
          </div>


          <div className="card-body p-2 sh_basecardBody sh_chart">
            <div className="d-flex flex-column gap-2">
            {icdList.length > 0 ? (
              icdList.map((item) => {
                const addedInDiagnosis=diagnoses.includes(item.icd10_id)
                const isChecked = selectedCodes.some((icd) => icd.code === item.code)
               
                const isAlreadyCheck =item.assessment_id || item.is_updated === true;
              
                const label=`${item.code} - ${convertUnderScoreStrings(item.description)}`
                return (
    
                    <div className="d-flex w-100 justify-content-between align-items-center" key={item.icd10_id}>
                        <p className="sh_emrtext p2-light mb-0">{label}</p>
                    <div className="w-25 px-1">
                      <div className="d-flex justify-content-end w-100">
                          {addedInDiagnosis?
                                   <span className="cursor-pointer" onClick={() => removeDiagnosis(item.icd10_id,label)} >
                                        <Icons type={"Remove"} fontSize={"23px"} />
                                    </span>
                                :
                                    <span  className="cursor-pointer" onClick={() => AddDiagnosis(item.icd10_id,label)} >
                                        <Icons type={"AddIconDetailView"} color={"#1D2433"} fontSize={"23px"} />
                                    </span>
                        }
                         
                      {/* <span
                       className={`sh_emr_roundbadge ${
                        isAlreadyCheck
                          ? "normal"
                          : isChecked
                          ? "chart"
                          : "inactive"
                      }`}
                        title="Chart"
                        role="checkbox"
                        aria-checked={isChecked}
                        tabIndex={0}
                        style={{ cursor: "pointer" }}
                        onClick={() => toggleCode(item.code, item.assessment_id, item.icd10_id,item.body_parts)}
                      >
                        C
                      </span> */}

                    </div>
                  </div>
                  </div>
                );
              })
            ) : aiSuggestionsEnabled ? (
              <div className="card-body px-0 py-2 sh_basecardBody sh_chart">
                <div className="ai-predictive-card h-100 d-flex flex-column" style={aiPredictiveCardStyle}>
                  <div
                    className={`d-flex align-items-center justify-content-between ${isAiPredictiveOpen ? "mb-3" : ""}`}
                    role="button"
                    tabIndex={0}
                    onClick={() => setIsAiPredictiveOpen((prev) => !prev)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        setIsAiPredictiveOpen((prev) => !prev);
                      }
                    }}
                  >
                    <div className="d-flex align-items-center gap-2" style={{ minWidth: 0 }}>
                      <span className="ai-predictive-icon d-flex align-items-center justify-content-center">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M12.0017 16.0019C12.0017 13.7918 13.7933 12.0002 16.0033 12.0002C13.7933 12.0002 12.0017 10.2086 12.0017 7.99854C12.0017 10.2086 10.2101 12.0002 8 12.0002C10.2101 12.0002 12.0017 13.7918 12.0017 16.0019Z"
                            stroke="url(#paint0_linear_ai_predictive)"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M21.0036 12.0001C21.0036 16.9727 16.9725 21.0038 11.9998 21.0038C7.02721 21.0038 2.99609 16.9727 2.99609 12.0001C2.99609 7.02745 7.02721 2.99634 11.9998 2.99634"
                            stroke="url(#paint1_linear_ai_predictive)"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M19.0052 7.99835C19.0052 6.34081 20.3489 4.9971 22.0064 4.9971C20.3489 4.9971 19.0052 3.65339 19.0052 1.99585C19.0052 3.65339 17.6615 4.9971 16.0039 4.9971C17.6615 4.9971 19.0052 6.34081 19.0052 7.99835Z"
                            stroke="url(#paint2_linear_ai_predictive)"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <defs>
                            <linearGradient
                              id="paint0_linear_ai_predictive"
                              x1="16.0033"
                              y1="12.0002"
                              x2="8"
                              y2="12.0002"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop offset="0.0625" stopColor="#9AA1FF" />
                              <stop offset="1" stopColor="#4474E6" />
                            </linearGradient>
                            <linearGradient
                              id="paint1_linear_ai_predictive"
                              x1="21.0036"
                              y1="12.0001"
                              x2="2.99609"
                              y2="12.0001"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop offset="0.0625" stopColor="#9AA1FF" />
                              <stop offset="1" stopColor="#4474E6" />
                            </linearGradient>
                            <linearGradient
                              id="paint2_linear_ai_predictive"
                              x1="22.0064"
                              y1="4.99709"
                              x2="16.0039"
                              y2="4.99709"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop offset="0.0625" stopColor="#9AA1FF" />
                              <stop offset="1" stopColor="#4474E6" />
                            </linearGradient>
                          </defs>
                        </svg>
                      </span>
                      <p className="mb-0 text-dark font-weight-bold" style={aiPredictiveTitleStyle}>
                        AI - Predictive Charting
                      </p>
                    </div>
                      <button
                        type="button"
                        className="btn btn-light sh_btnlight d-flex align-items-center justify-content-center"
                        aria-label="Reload suggestions"
                        title="Reload suggestions"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleReloadSuggestions(e);
                        }}
                        style={{ width: "34px", height: "34px", padding: 0 }}
                      >
                        <Icons type={"ReloadSuggestions"} size={16} color={"#4B5563"} />
                      </button>
                    <span
                      className="ai-secondary-nav-chevron d-flex align-items-center justify-content-center"
                      style={aiChevronStyle}
                    >
                      <svg fill="#000000" width="20" height="20" viewBox="-0.15 -0.225 0.72 0.72">
                        <path d="m0.212 0.085 -0.148 0.148A0.03 0.03 0 0 1 0.021 0.191L0.191 0.021a0.03 0.03 0 0 1 0.042 0l0.17 0.17a0.03 0.03 0 0 1 -0.042 0.042z" />
                      </svg>
                    </span>
                  </div>

                    {isAiPredictiveOpen && (
                      <>
                      <div className="ai-predictive-list flex-grow-1" style={aiPredictiveListStyle}>
                        {aiLoading && (
                          <div className="d-flex align-items-center justify-content-center py-2 text-center flex-column">
                            <div className="d-flex align-items-center justify-content-center mb-1">
                              <span
                                style={{
                                  width: 20,
                                  height: 20,
                                  borderRadius: "50%",
                                  border: "3px solid rgba(126, 224, 255, 0.3)",
                                  borderTopColor: "#7EE0FF",
                                  animation: "aiSpin 0.8s linear infinite",
                                  display: "inline-block",
                                  marginRight: 8,
                                }}
                              />
                              <span style={{ color: "#4B5563", fontSize: "13px", fontWeight: 500 }}>
                                Generating ICD-10 suggestions...
                              </span>
                            </div>
                            <span style={{ color: "#6B7280", fontSize: "12px" }}>
                              {aiLoadingMessages[aiLoadingStep]}
                            </span>
                          </div>
                        )}

                        {aiError && (
                          <div style={{ color: "#ff6b6b", fontSize: "13px", fontWeight: "500", padding: "8px", backgroundColor: "rgba(255, 107, 107, 0.1)", borderRadius: "8px" }}>
                            {aiError}
                          </div>
                        )}

                        {!aiLoading && !aiError && !isPollingForNewSuggestions && !hasCompletedPolling && aiSuggestions.length === 0 &&
                          (lastKnownSuggestionTimestamp === "CHECKED_EMPTY" || lastKnownSuggestionTimestamp === null) && (
                          <div style={{ color: "#4B5563", fontSize: "13px", textAlign: "center", padding: "8px" }}>
                            No suggestions available.
                          </div>
                        )}

                        {isPollingForNewSuggestions && (
                          <div className="d-flex align-items-center justify-content-center py-2 mb-2"
                            style={{
                              color: "#4474E6",
                              fontSize: "13px",
                              fontWeight: "600",
                              backgroundColor: "rgba(126, 224, 255, 0.12)",
                              borderRadius: "8px",
                              border: "1px solid rgba(126, 224, 255, 0.4)",
                            }}>
                            <span
                              style={{
                                width: 18,
                                height: 18,
                                borderRadius: "50%",
                                border: "3px solid rgba(126, 224, 255, 0.3)",
                                borderTopColor: "#4474E6",
                                animation: "aiSpin 0.8s linear infinite",
                                display: "inline-block",
                                marginRight: 8,
                              }}
                            />
                            Generating new suggestions...
                          </div>
                        )}

                        {!aiLoading && !aiError && aiSuggestions.map((item, index) => {
                          const currentItemIcdId = normalizeId(item.icd_id || item.matched_icd_id || item.icd10_id);
                          const isDiagnosisSelected =
                            currentItemIcdId !== "" &&
                            diagnoses.some((d) => normalizeId(d) === currentItemIcdId);
                          const isInAssessment =
                            item.is_in_assessment ||
                            item.is_accepted ||
                            isDiagnosisSelected;
                          return (
                            <div
                              key={`${item.id || item.code}-${index}`}
                              className={`ai-predictive-item d-flex align-items-start justify-content-between ${index === aiSuggestions.length - 1 ? "mb-0" : "mb-2"}`}
                              style={{
                                opacity: isInAssessment ? 0.6 : 1,
                                textDecoration: isInAssessment ? "line-through" : "none",
                                borderBottom:
                                  index === aiSuggestions.length - 1
                                    ? "none"
                                    : "1px solid #E5E7EB",
                                paddingBottom: index === aiSuggestions.length - 1 ? 0 : 8,
                              }}
                            >
                              <div className="me-3">
                                <p className="mb-1 font-weight-bold" style={aiPredictiveCodeStyle}>
                                  {item.code}
                                  {isInAssessment && <span className="ml-2 text-success">✓</span>}
                                </p>
                                <p className="mb-0 text-muted small" style={aiPredictiveDescStyle}>
                                  {item.description}
                                  <br />
                                  Confidence: {item.confidence != null
                                    ? (typeof item.confidence === "number"
                                        ? (item.confidence <= 1 ? `${Math.round(Number(item.confidence) * 100)}%` : `${Math.round(Number(item.confidence))}%`)
                                        : `${String(item.confidence)}`)
                                    : "N/A"}
                                </p>
                              </div>
                              <div style={{ paddingTop: "2px" }}>
                                <div>
                                  <input
                                    className=""
                                    type="checkbox"
                                    checked={isInAssessment}
                                    name=""
                                    id=""
                                    onChange={() => {
                                      if (!isInAssessment) {
                                        handleAcceptSuggestion(item);
                                      }
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          );
                        })}
                        <style>{`
                          @keyframes aiSpin {
                            from { transform: rotate(0deg) }
                            to { transform: rotate(360deg) }
                          }
                        `}</style>
                      </div>
                      {!aiLoading && !aiError && aiSuggestions.length > 0 && (
                        <div className="sh_cardFooter border-0 d-flex justify-content-between align-items-center" style={{ zIndex: 2 }}>
                          <small style={{ color: "#4B5563" }}>
                            {newSuggestionsAvailable ? "New suggestions available" : `${aiSuggestions.length} suggestions`}
                          </small>
                        </div>
                      )}
                      </>
                    )}
                </div>
              </div>
            ) : (
              <div className="d-flex align-items-center justify-content-center py-2">
                <p className="sh_emrtext p2-light mb-0">No ICD-10 codes found.</p>
              </div>
            )}
          </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withReduxState(NewIcdDisplay);
